// pipeline test

import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';

import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/BCI-style.css';
import './assets/css/bcicon.css';

import App from './containers/App';

if (process.env.NODE_ENV !== 'development' && console && typeof console.log === 'function') {
  console.log = () => undefined;
}

if (
  !!window.location.hash &&
  decodeURIComponent(window.location.hash).indexOf(
    'Rule: employer-tenant-lookup.js: No Tenant: The user cannot be authenticated. No active employers listed.'
  ) !== -1
) {
  window.location = '/error.html' + window.location.hash;
} else {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );
}
